import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../../app/rp_reducer";
import {OfferType} from "../../../types/OfferType";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {ILocationGenericParagraph, ParagraphType} from "../../helpers/location_generic_description/constants";
import {getLocationGenericDescription} from "../../helpers/location_generic_description/get_location_generic_description";
import {offerListDescriptionHolder} from "../OfferListSeoDescription";
import {ParagraphListType} from "./ParagraphRenderer/ParagraphListType";
import {ParagraphTableType} from "./ParagraphRenderer/ParagraphTableType";
import {ParagraphTextType} from "./ParagraphRenderer/ParagraphTextType";

interface IProps {
    className?: string;
    offerType: OfferType;
    filters?: {
        region?: string[];
        type?: number;
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
}

const allowedFilters = ["region", "type"];

const renderParagraph = (paragraph: ILocationGenericParagraph, index: number) => (
    <React.Fragment key={index}>
        {paragraph.type === ParagraphType.TEXT ? <ParagraphTextType text={paragraph.text} /> : null}
        {paragraph.type === ParagraphType.LIST ? <ParagraphListType texts={paragraph.text} /> : null}
        {paragraph.type === ParagraphType.TABLE ? (
            <ParagraphTableType caption={paragraph.caption} captionHidden={paragraph.captionHidden} headers={paragraph.headers} rows={paragraph.rows} />
        ) : null}
    </React.Fragment>
);

export const OfferListGenericLocationDescription = (props: IProps) => {
    const selectedRegionEstimatedPrices = useSelector((state: IRPStore) => state.offerList.selectedRegionEstimatedPrices);
    const forbiddenFilters = Object.keys(props.filters || {}).filter((filterName) => !allowedFilters.includes(filterName));

    if (forbiddenFilters.length > 0) {
        return null;
    }

    const sections = getLocationGenericDescription({
        offerType: props.offerType,
        filters: props.filters,
        region: props.region,
        selectedRegionEstimatedPrices
    });

    if (!Array.isArray(sections) || sections.length === 0) {
        return null;
    }

    return (
        <div css={[offerListDescriptionHolder]} className={props.className}>
            {sections?.map((section, sectionIndex) => (
                <React.Fragment key={section.headline}>
                    <Text as="h2" variant="headline_4" mb={2} className={sectionIndex > 0 ? sectionSpacingStyle : undefined}>
                        {section.headline}
                    </Text>

                    {section.description ? (
                        <Text variant="body_copy_1" className={descriptionStyle}>
                            {section.description}
                        </Text>
                    ) : null}

                    {section.updateDate ? (
                        <Text variant="body_copy_1" className={updateDateStyle}>
                            Dane pochodzą z bazy RynekPierwotny.pl i są aktualne na {section.updateDate}.
                        </Text>
                    ) : null}

                    {section.paragraphs.length > 0 ? section.paragraphs.map(renderParagraph) : null}

                    {section.subsections?.map((subsection) => (
                        <div key={subsection.headline} className={subsectionStyle}>
                            <Text as="h3" variant="headline_6" mb={1}>
                                {subsection.headline}
                            </Text>
                            {subsection.paragraphs.map(renderParagraph)}
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
};

const sectionSpacingStyle = css({
    marginTop: 3
});

const descriptionStyle = css({
    marginBottom: 2
});

const updateDateStyle = css({
    marginBottom: 2
});

const subsectionStyle = css({
    marginTop: 3
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../../app/rp_reducer";
import {OfferType} from "../../../types/OfferType";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {ILocationGenericParagraph, ParagraphType} from "../../helpers/location_generic_description/constants";
import {getLocationGenericDescription} from "../../helpers/location_generic_description/get_location_generic_description";
import {offerListDescriptionHolder} from "../OfferListSeoDescription";
import {ParagraphListType} from "./ParagraphRenderer/ParagraphListType";
import {ParagraphTableType} from "./ParagraphRenderer/ParagraphTableType";
import {ParagraphTextType} from "./ParagraphRenderer/ParagraphTextType";

interface IProps {
    className?: string;
    offerType: OfferType;
    filters?: {
        region?: string[];
        type?: number;
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
}

const allowedFilters = ["region", "type"];

const renderParagraph = (paragraph: ILocationGenericParagraph, index: number) => (
    <React.Fragment key={index}>
        {paragraph.type === ParagraphType.TEXT ? <ParagraphTextType text={paragraph.text} /> : null}
        {paragraph.type === ParagraphType.LIST ? <ParagraphListType texts={paragraph.text} /> : null}
        {paragraph.type === ParagraphType.TABLE ? (
            <ParagraphTableType caption={paragraph.caption} captionHidden={paragraph.captionHidden} headers={paragraph.headers} rows={paragraph.rows} />
        ) : null}
    </React.Fragment>
);

export const OfferListGenericLocationDescription = (props: IProps) => {
    const selectedRegionEstimatedPrices = useSelector((state: IRPStore) => state.offerList.selectedRegionEstimatedPrices);
    const forbiddenFilters = Object.keys(props.filters || {}).filter((filterName) => !allowedFilters.includes(filterName));

    if (forbiddenFilters.length > 0) {
        return null;
    }

    const sections = getLocationGenericDescription({
        offerType: props.offerType,
        filters: props.filters,
        region: props.region,
        selectedRegionEstimatedPrices
    });

    if (!Array.isArray(sections) || sections.length === 0) {
        return null;
    }

    return (
        <div css={[offerListDescriptionHolder]} className={props.className}>
            {sections?.map((section, sectionIndex) => (
                <React.Fragment key={section.headline}>
                    <Text as="h2" variant="headline_4" mb={2} className={sectionIndex > 0 ? sectionSpacingStyle : undefined}>
                        {section.headline}
                    </Text>

                    {section.description ? (
                        <Text variant="body_copy_1" className={descriptionStyle}>
                            {section.description}
                        </Text>
                    ) : null}

                    {section.updateDate ? (
                        <Text variant="body_copy_1" className={updateDateStyle}>
                            Dane pochodzą z bazy RynekPierwotny.pl i są aktualne na {section.updateDate}.
                        </Text>
                    ) : null}

                    {section.paragraphs.length > 0 ? section.paragraphs.map(renderParagraph) : null}

                    {section.subsections?.map((subsection) => (
                        <div key={subsection.headline} className={subsectionStyle}>
                            <Text as="h3" variant="headline_6" mb={1}>
                                {subsection.headline}
                            </Text>
                            {subsection.paragraphs.map(renderParagraph)}
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
};

const sectionSpacingStyle = css({
    marginTop: 3
});

const descriptionStyle = css({
    marginBottom: 2
});

const updateDateStyle = css({
    marginBottom: 2
});

const subsectionStyle = css({
    marginTop: 3
});
